const DEFAULT_CLINIC_TIMEZONE = "America/Sao_Paulo";

export function formatDate(
  dateString: string,
  includeTime = false,
  includeShortFormat = false,
  clinicTimezone?: string | null,
): string {
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(dateString);
  // Legacy SQL timestamps are UTC, like the offset-bearing API timestamps.
  const timestamp = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}(\.\d+)?$/.test(dateString)
    ? dateString.replace(" ", "T") + "Z"
    : dateString;
  const date = new Date(dateOnly ? dateString + "T00:00:00Z" : timestamp);
  if (!Number.isFinite(date.getTime()) || (dateOnly && date.toISOString().slice(0, 10) !== dateString)) return "—";

  let timeZone = dateOnly ? "UTC" : clinicTimezone || DEFAULT_CLINIC_TIMEZONE;
  try {
    new Intl.DateTimeFormat("pt-BR", { timeZone });
  } catch {
    timeZone = DEFAULT_CLINIC_TIMEZONE;
  }

  return date.toLocaleDateString("pt-BR", {
    year: "numeric",
    month: includeShortFormat ? "2-digit" : "numeric",
    day: includeShortFormat ? "2-digit" : "numeric",
    ...(!includeShortFormat && { weekday: "long" }),
    ...(!includeShortFormat && includeTime && !dateOnly && { hour: "numeric", minute: "numeric" }),
    timeZone,
  });
}
